/* Permet de mettre en surbrillance la couleur de la formule choisie dans un devis
*
*
* Paramètre :
* ID du tableau
* Position de la formule choisie
*
*
*/

    $( ".bt-devis--formule" ).click(function() {
        $("#"+$(this).attr("selection"))[0].className = $("#"+$(this).attr("selection"))[0].className.replace(/\bmonChoix.*?\b/g, '');
        $("#"+$(this).attr("selection")).addClass( "monChoix"+$(this).attr("choix") );
    });


